import React from 'react'
import { Tooltip, IconButton} from '@mui/material'
import { useNavigate } from 'react-router-dom';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';


function MechanicAction({title, page}) {

    const navigate= useNavigate()
  
   
  
    return (
  
       <Tooltip title={title}>
  
       <IconButton sx={{ color: '#489C8F', '&:hover': {backgroundColor: '#489C8F', color: 'white' } }}  onClick={()=>navigate(`/${page}`)}>
  
         <KeyboardDoubleArrowRightOutlinedIcon />
  
       </IconButton>
  
     </Tooltip>
  
    )
  
  }

export default MechanicAction